var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textColor"},_vm._l((6),function(n,i){return _c('div',{key:i,attrs:{"track-by":i}},[_c('p',{staticClass:"b"},[_vm._v(_vm._s(_vm.questions[i]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.answers[i]))])])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3d1250","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/FaqsEn.vue
// module id = 987
// module chunks = 4